import { createAction, props } from '@ngrx/store';
import { IFormMode } from '../../types/IFormMode';
import { Merchant } from '../../../core/domain/merchant/merchant';

export const openMerchantModal = createAction(
  '[Merchant Modal] Open Modal',
  props<{ mode: IFormMode; merchant?: Merchant }>()
);

export const closeMerchantModal = createAction('[Merchant Modal] Close Modal');

export const loadMerchants = createAction(
  '[Merchant] Load Merchants',
  props<{ merchants: Merchant[] }>()
);

export const createMerchant = createAction(
  '[Merchant] Create Merchant',
  props<{ merchant: Merchant }>()
);

export const updateMerchant = createAction(
  '[Merchant] Update Merchant',
  props<{ merchant: Merchant }>()
);

export const deleteMerchant = createAction(
  '[Merchant] Delete Merchant',
  props<{ merchantId: string }>()
);
